import LearningTypeSubtitle from "@/components/Search/utils/LearningTypeSubtitle";
import useElementEvents from "@/hooks/eventing/useElementEvents";
import { ElementType } from "@/constants/tagular/main";
import { usePathname } from "next/navigation";
import { getWebContext } from "@/utils/tagular/helpers";
import { useSearchMessages } from "@/i18n/hooks/useSearchMessages";
import { RefinementItem } from "@/components/Search/types";

const DropdownCheckboxItem = ({
  item,
  handleRefinementClick,
  filterCategory,
  position,
  indexName,
}: {
  item: RefinementItem;
  handleRefinementClick: (event: RefinementItem) => void;
  filterCategory: string;
  position: number;
  indexName: string;
}) => {
  const { getDisplayLabel } = useSearchMessages();
  const pathname = usePathname();

  // Generate slug from label (lowercase, replace spaces and special chars with hyphens)
  const generateSlug = (label: string): string => {
    return label
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  };

  const slug = generateSlug(item.label);
  const htmlId = `filter-${filterCategory}-${slug}`;

  // Element events for checkbox
  const { elementClicked: checkboxClicked } = useElementEvents({
    webElement: {
      elementType: ElementType.Button,
      htmlId,
      location: "degree-hub-filters",
      position: position.toString(),
      text: item.label,
    },
  });

  // Handle checkbox click event
  const handleCheckboxClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (typeof window === "undefined") return;

    // Extract page subcategory from pathname
    const subcategory = pathname?.replace("/", "") || "";
    const webBase = getWebContext();

    const eventData = {
      webElement: {
        elementType: "CHECKBOX", // Override to CHECKBOX instead of BUTTON
      },
      webContext: {
        ...webBase,
        userAgent: webBase?.userAgent ?? undefined,
        page: {
          url: pathname || "",
        },
      },
      customDimensions: [
        { key: "group", value: "degree-hub" },
        { key: "subcategory", value: subcategory },
      ],
    };

    checkboxClicked(eventData);
  };
  return (
    <div key={item.value}>
      <div
        key={item.label}
        className="py-[10px]"
        onClick={(e) => {
          // this prevents the default browser behavior of firing the
          // onClick event twice
          e.stopPropagation();
          handleRefinementClick({ ...item, isRefined: !item.isRefined });
        }}
      >
        <div className="flex justify-start items-start">
          <input
            type="checkbox"
            checked={item.isRefined}
            value={item.value}
            id={htmlId}
            onChange={handleCheckboxClick}
            className="border-2 mr-2 border-gray-700 min-w-4 h-5 w-5 cursor-pointer"
          />
          <div className="flex justify-start items-start flex-col">
            <label
              onClick={(e) => {
                e.stopPropagation();
              }}
              htmlFor={htmlId}
              className="text-gray-700 flex items-center mb-0 leading-5 text-sm"
            >
              {`${getDisplayLabel(item.label, filterCategory)} (${item.count})`}
            </label>
            <LearningTypeSubtitle
              filterCategory={filterCategory}
              itemValue={item.value}
              indexName={indexName}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DropdownCheckboxItem;
